import React from "react";
import { Check, Image as ImageIcon } from "lucide-react";
import { STATUS_MAP, igEmbed } from "./contentUtils";

export const DARK_STYLE = {
  backgroundColor: "#2D181E",
  backgroundImage: "radial-gradient(circle at 12% 0%, rgba(123,17,58,0.55), transparent 55%), radial-gradient(circle at 100% 100%, rgba(89,2,36,0.6), transparent 50%)",
};
export const HATCH = { backgroundImage: "repeating-linear-gradient(135deg, rgba(255,255,255,0.32) 0 2px, transparent 2px 7px)" };

export const StatusBadge = ({ status, className = "" }) => {
  const s = STATUS_MAP[status] || STATUS_MAP.idee;
  return <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${s.cls} ${className}`}>{s.label}</span>;
};

export const SectionCard = ({ children, className = "", ...rest }) => (
  <div className={`rounded-[28px] border border-line bg-white p-5 shadow-card sm:p-7 ${className}`} {...rest}>{children}</div>
);

export const DarkPanel = ({ children, className = "", ...rest }) => (
  <div className={`relative overflow-hidden rounded-[28px] p-6 text-white sm:p-8 ${className}`} style={DARK_STYLE} {...rest}>{children}</div>
);

export const Pill = ({ children, dark }) => (
  <span className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs ${dark ? "border border-white/10 bg-white/5 text-white/80" : "border border-line bg-white text-ink-soft"}`}>
    <span className={`h-1.5 w-1.5 rounded-full ${dark ? "bg-[#F3D2D9] ring-2 ring-[#F3D2D9]/25" : "bg-bordeaux ring-2 ring-bordeaux/30"}`} />{children}
  </span>
);

export const IconBubble = ({ icon: Icon, dark }) => (
  <span className={`flex h-11 w-11 items-center justify-center rounded-full ${dark ? "border border-white/10 bg-white/5 text-[#F3D2D9]" : "bg-bordeaux text-white"}`}><Icon size={18} /></span>
);

export const AccentButton = ({ icon: Icon, children, onClick, testid, className = "" }) => (
  <button data-testid={testid} onClick={onClick} className={`group inline-flex items-center gap-2 rounded-full bg-bordeaux py-1.5 pl-1.5 pr-5 text-sm font-medium text-white transition-transform hover:-translate-y-0.5 ${className}`}>
    <span className="flex h-7 w-7 items-center justify-center rounded-full bg-white/15">{Icon && <Icon size={14} />}</span>{children}
  </button>
);

export const Toggle = ({ on, onChange, testid }) => (
  <button data-testid={testid} onClick={(e) => { e.stopPropagation(); onChange(!on); }} className={`relative h-5 w-9 shrink-0 rounded-full transition-colors ${on ? "bg-bordeaux" : "bg-line"}`}>
    <span className={`absolute left-0 top-0.5 h-4 w-4 rounded-full bg-white shadow transition-transform ${on ? "translate-x-4" : "translate-x-0.5"}`} />
  </button>
);

export const CheckDot = ({ on }) => (
  <span className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full ${on ? "bg-bordeaux-dark text-white" : "border border-line bg-white"}`}>{on && <Check size={12} strokeWidth={3} />}</span>
);

export const MediaPreview = ({ url, image, className = "", tall }) => {
  const embed = igEmbed(url);
  if (image) return <img src={image} alt="" className={`h-full w-full object-cover ${className}`} />;
  if (embed) {
    return (
      <div className={`relative h-full w-full overflow-hidden bg-white ${className}`}>
        <iframe title="Aperçu Instagram" src={embed} loading="lazy" scrolling="no" className="pointer-events-none absolute border-0" style={tall ? { top: -55, left: "-21%", width: "142%", height: "calc(100% + 700px)" } : { top: -55, left: 0, width: "100%", height: "calc(100% + 600px)" }} />
      </div>
    );
  }
  return <div className={`flex h-full w-full items-center justify-center bg-bordeaux-tint text-bordeaux/50 ${className}`}><ImageIcon size={28} /></div>;
};
